import React, { useState, useMemo, useEffect } from "react";
import { Link } from "react-router-dom";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import TableContainer from "../../Components/Common/TableContainer";
import { Col, Row, Card, CardBody } from "reactstrap";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import { toast, ToastContainer } from "react-toastify";
import { getRequests, deleteRequest, getOtherServices } from "utils/apiService";
import DeleteModal from "Components/Common/DeleteModal";

function OtherServicesList() {
  document.title = "Other Requested Services";
  const [requests, setRequests] = useState([]);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  useEffect(() => {
    fetchRequests();
  }, []);

  const fetchRequests = async () => {
    try {
      const data = await getOtherServices();
      setRequests(data.response);
    } catch (err) {
      console.error("Failed to fetch students:", err);
    }
  };

  const columns = useMemo(
    () => [
      {
        header: "Name",
        accessorKey: "name",
      },
      {
        header: "Payment ID",
        accessorKey: "payment_id",
      }
    ],
    []
  );

  return (
    <React.Fragment>
     
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs breadcrumbItem="Other Requested Services" />
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={requests}
                    isGlobalFilter={false}
                    isAddButton={false}
                    customPageSize={10}
                    isPagination={true}
                    tableClass="align-middle table-nowrap dt-responsive nowrap w-100"
                    theadClass="table-light"
                    pagination="pagination"
                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
}

export default OtherServicesList;
